var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"acc2756556ea4c946f5a4566965cba3aea3336b3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["magal@magal-jewelry"]={id:"acc2756556ea4c946f5a4566965cba3aea3336b3"};
      